import React, { useMemo } from 'react';
import { MoldOrder, MoldOrderStatus, MoldOrderType, MoldOrderFirstLevelType } from '../../types/mold';
import { useNavigate } from 'react-router-dom';
import { getMoldOrdersTableColumns } from './utils/tableColumns';
import TableComponent from '../shared/TableComponent';
import { ClientCompanyCode } from '../../models/appState';

interface TableViewProps {
  moldOrders: MoldOrder[];
  onDataChange?: (data: MoldOrder[]) => void;
  visibleColumns?: Record<string, boolean>;
  getStatusText?: (status: MoldOrderStatus, type?: MoldOrderType) => string;
  getMoldOrderTypeLabel?: (type: MoldOrderType) => string;
  boardType?: MoldOrderFirstLevelType;
  companyCode?: ClientCompanyCode;
}

const TableView: React.FC<TableViewProps> = ({ 
  moldOrders, 
  onDataChange,
  visibleColumns,
  getStatusText,
  getMoldOrderTypeLabel,
  boardType,
  companyCode
}) => {
  const navigate = useNavigate();
  
  const handleRowClick = (order: MoldOrder) => {
    const queryParams = new URLSearchParams();
    queryParams.append('source', 'kanban');
    if (boardType) {
      queryParams.append('boardType', boardType);
    }
    navigate(`/mold-orders/${order.id}?${queryParams.toString()}`);
  };
  const columns = useMemo(() => {
    return getMoldOrdersTableColumns({ 
      statusFilterable: true,
      getStatusText,
      getMoldOrderTypeLabel,
      companyCode,
    });
  }, [getStatusText, getMoldOrderTypeLabel, companyCode]);

  // If no visibleColumns provided, show all columns
  const effectiveVisibleColumns = visibleColumns || 
    columns.reduce(
      (acc, column) => ({
        ...acc,
        [column.key]: true,
      }),
      {}
    );

  return (
    <div className="bg-white shadow-md">
      <TableComponent<MoldOrder>
        data={moldOrders}
        columns={columns}
        visibleColumns={effectiveVisibleColumns}
        onRowClick={handleRowClick}
        onDataChange={onDataChange}
        savePreferenceSettings={{
          isEnable: true,
          key: 'kanbanMoldOrderTable',
        }}
      />
    </div>
  );
};

export default TableView;